(() => {
  const resetTimers = new WeakMap();

  function fallbackCopy(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '-9999px';
    textarea.style.opacity = '0';
    textarea.style.pointerEvents = 'none';
    document.body.appendChild(textarea);

    textarea.focus({ preventScroll: true });
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    let copied = false;
    try {
      copied = document.execCommand('copy');
    } finally {
      textarea.remove();
    }

    if (!copied) throw new Error('Fallback copy command failed');
  }

  async function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return;
      } catch (_) {
        // Theme editor previews can expose navigator.clipboard while blocking permission.
        // Fall through to the legacy user-gesture copy method.
      }
    }

    fallbackCopy(text);
  }

  function showCopied(button) {
    const previousTimer = resetTimers.get(button);
    if (previousTimer) window.clearTimeout(previousTimer);

    button.dataset.copied = 'true';
    button.setAttribute('aria-label', 'Prompt copied');

    const timer = window.setTimeout(() => {
      delete button.dataset.copied;
      button.setAttribute('aria-label', 'Copy prompt');
      resetTimers.delete(button);
    }, 1800);

    resetTimers.set(button, timer);
  }

  document.addEventListener('click', async (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('[data-copy-prompt-button]');
    if (!(button instanceof HTMLButtonElement)) return;

    event.preventDefault();

    const component = button.closest('[data-copy-prompt]');
    const textElement = component?.querySelector('[data-copy-prompt-text]');
    const text = textElement?.textContent?.trim();

    if (!text) return;

    try {
      await copyText(text);
      showCopied(button);
    } catch (error) {
      console.warn('[PollenPro copy prompt] Unable to copy prompt.', error);
    }
  });
})();
